import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { TranslationKey } from '~/lib';
import { useErrorHandler } from '~/shared/utils/errorBoundary/hooks/useErrorHandler';
import { useTranslation } from '~/shared/utils/translation';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';

const Toast = () => {
    const { query } = useRouter();
    const { displayOnlyError } = useErrorHandler();
    const { translate } = useTranslation();

    useEffect(() => {
        if (query.error) {
            displayOnlyError(
                translate(query.error as unknown as TranslationKey) ||
                    translate('message.generalErrorMessage'),
            );
        }
    }, []);

    useEffect(() => {
        const productRedirect = Cookies.get('productRedirect');

        if (productRedirect) {
            const redirectText =
                productRedirect === 'alternative'
                    ? translate('message.productIsDiscontinuedAlternative')
                    : translate('message.productIsDiscontinuedCategory', {
                          category: productRedirect ?? 'kategori',
                      });

            toast(redirectText, {
                autoClose: false,
                closeButton: true,
                toastId: 'redirecttoast',
                theme: 'dark',
                onOpen: () => Cookies.remove('productRedirect'),
                containerId: 'toastmaincontainer',
            });
        } else {
            toast.dismiss('redirecttoast');
        }
    }, [query]);

    return (
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            containerId="toastmaincontainer"
            enableMultiContainer
        />
    );
};

export default Toast;
